export function getURLByEnv(): string {
    if (process.env.NODE_ENV == "production") {
        return "/admin";
    } else {
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/utils/URL.ts